import { Button, Tooltip } from '@payaca/ambrosia';
import UntitledIcon from '@payaca/untitled-icons';
import { FC, ReactNode } from 'react';

/**
 * An (i) icon with at most one short line on hover or focus. Anything longer
 * belongs in a label/value row or nowhere: the designer has no help modals.
 */
const DesignerHelp: FC<{ title: string; children: ReactNode }> = (props) => (
  <Tooltip tooltipContent={props.children} placement="top">
    <Button
      variant="quaternary"
      size="sm"
      className="min-h-11 min-w-11 px-2 sm:min-h-0 sm:min-w-0"
      aria-label={props.title}
    >
      <UntitledIcon name="info-circle.3" className="size-4" />
    </Button>
  </Tooltip>
);

export default DesignerHelp;
